import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "status-container"
}
const _hoisted_2 = { class: "block" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_ctx.showStatusBiometry)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.statusBiometry !== 'maximumNumberExceeded')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _ctx.statusIcon,
                  alt: _ctx.statusAlt,
                  class: _normalizeClass(_ctx.statusBiometry === 'fatalError' ? 'fatal-error-icon' : 'img-icon')
                }, null, 10, _hoisted_4)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
          (_ctx.description)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.description), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.restartDecs)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["btn-block", {
        'redirect-class': _ctx.isRedirectToMyBeeline,
      }])
            }, [
              (_ctx.restartIdentification)
                ? (_openBlock(), _createBlock(_component_ButtonComponent, {
                    key: 0,
                    class: _normalizeClass([_ctx.primaryButtonClass, "primary-button"]),
                    onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.restartBiometry()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.restartDecs), 1)
                    ]),
                    _: 1
                  }, 8, ["class"]))
                : _createCommentVNode("", true),
              (_ctx.isRedirectToMyBeeline)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_ctx.restartIdentification)
                      ? (_openBlock(), _createBlock(_component_ButtonComponent, {
                          key: 0,
                          class: "primary-button",
                          onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectToMyBeeline()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('deviceRegistration.messages.redirectToMyBeeline')), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_ButtonComponent, {
                          key: 1,
                          class: "primary-button",
                          onOnClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.redirectToMyBeeline()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('beeLiveScanner.errBtnText.redirectToMyBeeline')), 1)
                          ]),
                          _: 1
                        }))
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.restartIdentification && _ctx.noAccessToCamera)
                ? (_openBlock(), _createBlock(_component_ButtonComponent, {
                    key: 2,
                    class: _normalizeClass(["primary-button", {
          'redirect-color': _ctx.statusBiometry === 'noAccessCamera',
        }]),
                    onOnClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToNumberRegistrationPage()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.restartDecs), 1)
                    ]),
                    _: 1
                  }, 8, ["class"]))
                : _createCommentVNode("", true),
              (_ctx.showBackToStartButton)
                ? (_openBlock(), _createBlock(_component_ButtonComponent, {
                    key: 3,
                    class: _normalizeClass(["primary-button", { 'redirect-color': _ctx.statusBiometry === 'deviceRegistration' }]),
                    onOnClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.backToStart()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.restartDecs), 1)
                    ]),
                    _: 1
                  }, 8, ["class"]))
                : _createCommentVNode("", true),
              (_ctx.statusBiometry === 'deviceRegistration')
                ? (_openBlock(), _createBlock(_component_ButtonComponent, {
                    key: 4,
                    class: "primary-button",
                    onOnClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.restartBiometry()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('deviceRegistration.messages.errors.registration.btn1')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.statusBiometry === 'maximumNumberExceeded')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_ButtonComponent, {
                      class: "primary-button",
                      onOnClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.redirectToMoreDetails()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('phoneRegistration.errors.btnMoreDetails')), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}